// Centralized time formatting helpers.
// Keep both timeFromNow and shortAgo to preserve existing component behavior.
// Small improvement: handle future timestamps gracefully.
function toDate(input) {
    return input instanceof Date ? input : new Date(input);
}
// Same semantics as existing scattered versions: returns a terse relative string.
// Examples: '3m', '2h', '5d', '3w', '4mo', '2y'
export function timeFromNow(iso) {
    const now = Date.now();
    const d = toDate(iso).getTime();
    if (isNaN(d))
        return '—';
    let diff = Math.floor((now - d) / 1000);
    if (diff < 0)
        diff = 0; // future-proofing
    const minute = 60;
    const hour = 60 * minute;
    const day = 24 * hour;
    const week = 7 * day;
    const month = 30 * day;
    const year = 365 * day;
    if (diff < minute)
        return `${Math.floor(diff)}s`;
    if (diff < hour)
        return `${Math.floor(diff / minute)}m`;
    if (diff < day)
        return `${Math.floor(diff / hour)}h`;
    if (diff < week)
        return `${Math.floor(diff / day)}d`;
    if (diff < month)
        return `${Math.floor(diff / week)}w`;
    if (diff < year)
        return `${Math.floor(diff / month)}mo`;
    return `${Math.floor(diff / year)}y`;
}
// Original shortAgo implementation variants: used for interaction lists, similar thresholds.
export function shortAgo(iso) {
    if (!iso)
        return '—';
    const raw = timeFromNow(iso);
    // Map terse units to suffixed version matching previous panels (e.g. '3m ago')
    if (raw === '0s')
        return 'just now';
    return raw + ' ago';
}
// Verbose variant preserving earlier phrasing used in leads tables.
// Examples: 'just now', 'a minute ago', '3m ago', 'an hour ago', '5h ago', '2d ago', '3mo ago'
export function timeFromNowVerbose(iso) {
    const d = toDate(iso).getTime();
    if (isNaN(d))
        return '—';
    let diff = Date.now() - d;
    if (diff < 0)
        diff = 0;
    const sec = Math.floor(diff / 1000);
    if (sec < 45)
        return 'just now';
    if (sec < 90)
        return 'a minute ago';
    const min = Math.floor(sec / 60);
    if (min < 45)
        return `${min}m ago`;
    if (min < 90)
        return 'an hour ago';
    const hr = Math.floor(min / 60);
    if (hr < 24)
        return `${hr}h ago`;
    const day = Math.floor(hr / 24);
    if (day < 30)
        return `${day}d ago`;
    const month = Math.floor(day / 30);
    if (month < 12)
        return `${month}mo ago`;
    const year = Math.floor(day / 365);
    return `${year}y ago`;
}
